import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Shield,
  Key,
  Grid,
  Building2,
  Contact,
  TrendingUp,
  CheckSquare,
  FileText,
  Package,
  Tags,
  Settings,
  Truck,
  FolderKanban,
  ShoppingCart,
  DollarSign,
  BarChart3,
  UserCircle,
  IndianRupee,
  ChevronDown
} from "lucide-react";
import { ROUTES } from "../../../constants/webRouting";
import { useState } from "react";
// import { useModules } from "../store/hooks/useModules";
// import { useAuth } from "../store/hooks/useAuth";
// import Logo from "./Logo";
// import Logo from "../../../assets/img/solisPowerLogo.png";


// Icon mapping for modules
const moduleIcons = {
  dashboard: LayoutDashboard,
  users: Users,
  roles: Shield,
  permissions: Key,
  modules: Grid,
  accounts: Building2,
  contacts: Contact,
  leads: TrendingUp,
  tasks: CheckSquare,
  quotations: FileText,
  products: Package,
  categories: Tags,
  settings: Settings,
  vendors: Truck,
  projects: FolderKanban,
  "purchase-orders": ShoppingCart,
  inventory: Package,
  payments: DollarSign,
  reports: BarChart3,
};



export default function Sidebar({ isOpen, onClose, isDesktop = true }) {
  const [openMenus, setOpenMenus] = useState({});

  // const { accessibleModules, loading } = useModules();
  // const { user } = useAuth();

  // Build menu items from accessible modules
  const menuItems = [
    // { path: "/", name: "dashboard", label: "Dashboard", icon: LayoutDashboard }, // Add Comment By Jaseem -> 12-02-2026
  ];

  // Add accessible modules to menu (super admin gets all modules from backend)
  // if (!loading && accessibleModules) {
  let accessibleModules;
  // accessibleModules.forEach((module) => {
  //     const icon = moduleIcons[module.name] || Grid;
  //     menuItems.push({
  //       path: `/${module.name}`,
  //       name: module.name,
  //       label: module.display_name,
  //       icon,
  //     });
  //   });
  // }

  // For super admin, also add direct access to admin modules if not already included
  // if (user?.isSuperAdmin) {
  const adminModules = [
    {
      path: ROUTES.HOME,
      name: "home",
      label: "Home",
      path: "/", // Added By Jaseem -> 12-02-2026
      icon: LayoutDashboard,
    },

    {
      name: "lead-management",
      label: "Lead Management",
      icon: Users,
      children: [
        {
          path: ROUTES.LEAD.LIST,
          name: "leads",
          label: "Leads",
        },
        {
          path: ROUTES.USER_TRACKING,
          name: "site-visit",
          label: "Site Visit",
        },
        {
          path: ROUTES.PROJECT.LIST,
          name: "projects",
          label: "Projects",
        },
      ],
    },

    // {
    //   name: "potential-customer",
    //   label: "Vendor Management",
    //   icon: IndianRupee,
    //   children: [
    //     {
    //       path: ROUTES.COMMISSION.LIST,
    //       name: "commission-management",
    //       label: "Commission Management",
    //     },
    //     {
    //       path: ROUTES.CONTACT.LIST,
    //       name: "contact",
    //       label: "Contact",
    //     },
    //   ],
    // },
    {
      name: "masters",
      label: "Masters",
      icon: Settings,
      children: [
        {
          path: ROUTES.PRODUCT.LIST,
          name: "products",
          label: "Products",
        },
        {
          path: ROUTES.BRAND.LIST,
          name: "brand",
          label: "Brand",
        },
        {
          path: ROUTES.BOM.LIST,
          name: "bom",
          label: "BOM (Bill Of Material)",
        },
        {
          path: ROUTES.COMMISSION.LIST,
          name: "commission-management",
          label: "Commission Management",
        },
        {
          path: ROUTES.CATEGORY.LIST,
          name: "categories",
          label: "Category",
        },
        {
          path: ROUTES.SPECIFICATION.LIST,
          name: "specifications",
          label: "Specification",
        },
        {
          path: ROUTES.CONTACT.LIST,
          name: "contact",
          label: "Contact",
        },
        {
          path: ROUTES.USER.LIST,
          name: "users",
          label: "Users",
        },
      ],
    },
    {
      path: ROUTES.QUOTATION.LIST,
      name: "quotation",
      label: "Quotation",
      icon: FileText,
    },
  ];


  // Only add if not already in menuItems
  adminModules.forEach((adminModule) => {
    // if (!menuItems.find((item) => item.path === adminModule.path)) 
    if (!menuItems.find((item) => item.name === adminModule.name)) {
      menuItems.push(adminModule);
    }
  });
  // }

  /* Added by Farhan Khan on 12-Feb-2026 - Sidebar: fixed left, 100vh, independent scroll via crm-sidebar__nav */
  const sidebarClass = [
    "crm-sidebar",
    !isOpen ? "crm-sidebar--collapsed" : "",
    !isDesktop && isOpen ? "crm-sidebar--open" : "",
  ]
    .filter(Boolean)
    .join(" ");


  const toggleMenu = (name) => {
    setOpenMenus((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };


  const location = useLocation();
  const isChildActive = (children) => {
    return children.some(child =>
      location.pathname === child.path ||
      location.pathname.startsWith(child.path + "/")
    );
  };
  return (
    <aside className={sidebarClass}>
      <div className="vh-100 flex flex-col">
        <div className="logo-section border-b flex-shrink-0">
          {/* <Logo /> */}
          {/* <img
          src="https://i.ibb.co/WWth5gCf/solis-Power-Logo.png"
          alt="Solis Power"
          style={{ width: "200px", height: "55px" }}
        /> */}
        </div>
        <nav className="flex-1 p-1 space-y-2 side-navbar crm-sidebar__nav">
          <div className="ms-1 p-3">
            <img
              src="https://i.ibb.co/WWth5gCf/solis-Power-Logo.png"
              alt="Solis Power"
              style={{ width: "150px", height: "55px", margin: "auto" }}
            />
          </div>

          {menuItems.map((item) => {
            const Icon = item.icon;

            // ---------------- DROPDOWN ITEM ----------------
            if (item.children) {
              const isOpen = openMenus[item.name];

              return (
                // <div key={item.name}>
                //   <div
                //     onClick={() => toggleMenu(item.name)}
                //     className=" bg-black text-white flex items-center justify-between gap-3 px-3 py-3 rounded-lg cursor-pointer hover:bg-gray-100"
                //   >
                //     <div className="flex items-center gap-3">
                //       <Icon className="w-5 h-5" />
                //       <span>{item.label}</span>
                //     </div>

                //     <ChevronDown
                //       className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""
                //         }`}
                //     />
                //   </div>

                //   {isOpen && (
                //     <div className="ml-8 mt-1 space-y-1">
                //       {item.children.map((child) => (
                //         <NavLink
                //           key={child.path}
                //           to={child.path}
                //           className={({ isActive }) =>
                //             `block px-3 py-2 rounded-md text-sm transition-colors ${isActive
                //               ? "active-link"
                //               : "text-gray-600 hover:bg-gray-100"
                //             }`
                //           }
                //           onClick={() => {
                //             if (window.innerWidth < 1024) onClose();
                //           }}
                //         >
                //           {child.label}
                //         </NavLink>
                //       ))}
                //     </div>
                //   )}
                // </div>
                <div key={item.name}>
                  {/* 👇 parent active detect */}
                  {(() => {
                    const parentActive = isChildActive(item.children);

                    return (
                      <>
                        <div
                          onClick={() => toggleMenu(item.name)}
                          className={`flex items-center justify-between gap-3 px-3 py-3 rounded-lg cursor-pointer transition-colors
            ${parentActive
                              ? "menu-parents-items text-white"
                              : "text-white"
                            }`}
                        >
                          <div className="flex items-center gap-3">
                            <Icon className="w-5 h-5" />
                            <span>{item.label}</span>
                          </div>

                          <ChevronDown
                            className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""
                              }`}
                          />
                        </div>

                        {isOpen && (
                          <div className="ml-8 mt-1 space-y-1 p-3 grey-color">
                            {item.children.map((child) => (
                              <NavLink
                                key={child.path}
                                to={child.path}
                                className={({ isActive }) =>
                                  `block px-3 py-2 rounded-md text-sm transition-colors ${isActive
                                    ? "active-link bg-blue-500 text-white"
                                    : "text-gray-600 hover:bg-gray-100"
                                  }`
                                }
                                onClick={() => {
                                  if (window.innerWidth < 1024) onClose();
                                }}
                              >
                                {child.label}
                              </NavLink>
                            ))}
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
              );
            }

            // ---------------- NORMAL ITEM ----------------
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-3 rounded-lg transition-colors ${isActive ? "active-link" : "hover:bg-gray-100"
                  }`
                }
                onClick={() => {
                  if (window.innerWidth < 1024) onClose();
                }}
              >
                <Icon className="w-5 h-5" />
                <span>{item.label}</span>
              </NavLink>
            );
          })}

          {/* PROFILE */}
          <NavLink
            to="/profile"
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-3 rounded-lg transition-colors ${isActive ? "active-link" : "hover:bg-gray-100"
              }`
            }
            onClick={() => {
              if (window.innerWidth < 1024) onClose();
            }}
          >
            <UserCircle className="w-5 h-5" />
            <span>My Profile</span>
          </NavLink>
        </nav>
      </div>
    </aside>
  );
}